import { CloseOutlined } from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import { useState, useEffect } from "react";
import { orderStatuses } from "../../extensions/helper";

const LicenseFilter = ({ value, onClose }) => {
  const emptyFilter = { searchText: '' };
  const [tempFilter, setTempFilter] = useState(value ?? emptyFilter);

  useEffect(() => {
    setTempFilter(value ?? emptyFilter);
  }, [value]);

  const onSearchChange = (changed) => {
    const text = changed.search.toLowerCase();
    setTempFilter(prev => ({ ...prev, search: text }));
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="payments-mobile-filter-container">
            <Input placeholder="Поиск по компании, email" allowClear style={{ maxWidth: 420, marginRight: 8 }}
              value={tempFilter?.search} onChange={(e) => onSearchChange({ search: e.target.value })}/>
            <Select placeholder="Статусы" mode="multiple" value={tempFilter?.statuses} onChange={(val) => setTempFilter(prev => ({ ...prev, statuses: val }))}
              options={orderStatuses} allowClear className="client-filter-select"/>
            <Button onClick={() => onClose(tempFilter)}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseFilter;
